import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Performance › Forecasting (leaf).
export const forecasting: ContentPage = {
  slug: "sales-performance/forecasting",
  template: "hrmsFeature",
  seo: {
    title: "Sales Forecasting Software - Predict Revenue | GetBiz CRM",
    description: "Forecast revenue accurately with GetBiz CRM. Build pipeline-based, category and quota forecasts and track them against targets in real time.",
    keywords: ["sales forecasting software", "revenue forecasting", "crm forecasting", "pipeline forecast"],
    ogImage: "/assets/data/seoimages/forecasting.webp",
  },
  leaf: {
    hero: {
      caption: "Forecasting",
      title: "Forecast Revenue You Can Actually Trust",
      description: "Build data-driven forecasts from your live pipeline, so leadership always has an accurate view of what will close.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Forecasting",
      bullets: [
        { title: "Pipeline-Based", description: "Forecast from real deal stages, values and close dates." },
        { title: "Category Forecasts", description: "Roll up best-case, commit and closed views." },
        { title: "Quota Tracking", description: "See attainment by rep and team against quota." },
        { title: "Trend History", description: "Compare forecast accuracy over time." },
      ],
      image: "/assets/images/img/product/crm/forecasting-lead-image.webp",
      imageAlt: "Forecasting — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Performance",
      description: "Forecasting connects to every other part of Sales Performance in GetBiz CRM.",
    },
    cards: [
      { title: "Multiple Currencies", href: "/crm-software/sales-performance/multiple-currencies/", description: "Quote, close and report across currencies with live exchange rates.", image: "/assets/images/img/product/crm/multiple-currencies.webp", imageAlt: "GetBiz CRM multiple currencies" },
      { title: "Analytics", href: "/crm-software/sales-performance/analytics/", description: "Dig into performance across reps, products and regions to understand the behaviors and deals that drive revenue.", image: "/assets/images/img/product/crm/analytics-sub.webp", imageAlt: "GetBiz CRM analytics" },
      { title: "Visitor Tracking", href: "/crm-software/sales-performance/visitor-tracking/", description: "Identify the companies browsing your site, see what they view, and turn anonymous traffic into warm, timely outreach.", image: "/assets/images/img/product/crm/visitor-tracking.webp", imageAlt: "GetBiz CRM visitor tracking" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Forecasting in action.",
    relatedBlogs: "static",
    metaKey: "sales-performance-forecasting",
  },
  sections: [],
};
